import {loadable} from "jotai/utils";
import {atomWithRefresh} from "../utils/jotaiUtils";
import {getMapToken} from "../services/mapTokenService";

/**
 * MapBox token
 */
export const mapTokenAtom = atomWithRefresh<Promise<string>>(async () => await getMapToken());

export const mapTokenLoadable = loadable(mapTokenAtom);
